import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// @mui
// routes

// _mock_
// components
import {
  emptyRows,
  getComparator,
  TableEmptyRows,
  TableHeadCustom,
  TableNoData,
  TablePaginationCustom,
  useTable,
} from "../../../components/table";
// sections
import {
  Button,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TextField,
} from "@mui/material";
import { getLoggedInUser } from "src/auth/utils";
import Iconify from "src/components/iconify";
import Scrollbar from "src/components/scrollbar";
import AssessmentController from "src/controller/Assessment.controller";
import StudentController from "src/controller/Student.controller";
import { useProgram } from "src/hooks/useProgram";
import { PATH_DASHBOARD } from "src/routes/paths";
import { AssessmentTableRow } from "../list";
import StudentTabContainer from "../sections/StudentTabContainer.section";
import AddAssessment from "./AddAssessment";
import AddAssessmentScoreTab from "./AddAssessmentScoreTab";
import AssessmentReport from "./AssessmentReport";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { label: "Title", align: "left" },
  { label: "Subject", align: "left" },
  { label: "Group", align: "left" },
  { label: "Date", align: "left" },
  // { label: "Score", align: "left" },
  { label: "Action", align: "center" },
];

let Assessments = [];
let AddAssessmentPage = true;

export default function AssessmentPage({
  enrollments,
  student,
  hideActions = false,
}) {
  const { assessment_id } = useParams();

  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    selected,
    setSelected,
    onSelectRow,

    onSort,
    onChangeDense,
    onChangePage,
    onChangeRowsPerPage,
  } = useTable();

  const params = useParams();
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [assessmentOpen, setAssessmentOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const reset = () => {
    setTableData([]);
  };
  const { program, handleProgramChange } = useProgram(id, reset);

  const dataFiltered = applyFilter({
    inputData: tableData,
    comparator: getComparator(order, orderBy),
    filterName,
    filterStatus,
  });

  const dataInPage = dataFiltered?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const denseHeight = dense ? 52 : 72;

  const isFiltered = filterName !== "" || filterStatus !== "all";

  const isNotFound =
    (!dataFiltered?.length && !!filterName) ||
    (!dataFiltered?.length && !!filterStatus);

  const handleDeleteRow = async (id) => {
    if (id) {
      AssessmentController.delete(id)
        .then((id) => {
          window.Toast("Assessment Deleted Successfully");
          setIsLoading(true);
          fetchStudentAssessments();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleAddAssessmentScore = (assessment_id) => {
    window.redirect(
      `${PATH_DASHBOARD.student.tab(
        id,
        "assessments"
      )}/${assessment_id}/add-score`
    );
  };

  const handleAssessment = () => {
    setAssessmentOpen(true);
  };

  const handleAssessmentClose = () => {
    setAssessmentOpen(false);
    fetchStudentAssessments();
  };

  const fetchStudentAssessments = async () => {
    setIsLoading(true);

    try {
      if (id) {
        const data = await StudentController.getAssessments(id);
        setTableData(data.filter((i) => i.subject_code === program) ?? []);
      }
    } catch (err) {
      console.log(`Api Error: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentAssessments();
  }, [id, program]);

  useEffect(() => {
    fetchStudentAssessments();
    if (assessment_id) {
      AddAssessmentPage = true;
    }

    const user = getLoggedInUser();
    if (user.role === "student") {
      setId(user.student_id);
    } else {
      setId(params.id);
    }
  }, []);

  if (AddAssessmentPage && window.location.href.includes("add-score")) {
    return <AddAssessmentScoreTab enrollments={enrollments} />;
  }

  return (
    <StudentTabContainer title="Assessments">
      <Stack
        sx={{ mt: 2, mb: 2 }}
        fullWidth
        display="flex"
        justifyContent="space-between"
        direction="row"
      >
        <TextField
          fullWidth
          select
          label="Program"
          size="small"
          value={program}
          onChange={(event) => handleProgramChange(event.target.value)}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: {
                  maxHeight: 260,
                },
              },
            },
          }}
          sx={{
            maxWidth: { sm: 340 },
            textTransform: "capitalize",
          }}
        >
          {enrollments
            ?.reduce((acc, curr) => {
              if (
                curr.program_name &&
                curr.program_name.trim() !== "" &&
                !acc.includes(curr.program_name)
              ) {
                acc.push(curr.program_name);
              }
              return acc;
            }, [])
            .map((programName) => (
              <MenuItem
                key={programName}
                value={programName}
                sx={{
                  mx: 1,
                  borderRadius: 0.75,
                  typography: "body2",
                  textTransform: "capitalize",
                }}
              >
                {programName}
              </MenuItem>
            ))}
        </TextField>

        {!hideActions && (
          <Button
            size="small"
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={handleAssessment}
          >
            Add Assessment
          </Button>
        )}
      </Stack>

      <TableContainer sx={{ position: "relative", overflow: "unset" }}>
        <Scrollbar>
          <Table size={dense ? "small" : "medium"} sx={{ minWidth: 800 }}>
            <TableHeadCustom
              order={order}
              orderBy={orderBy}
              headLabel={
                hideActions
                  ? TABLE_HEAD.filter((h) => h.label !== "Action")
                  : TABLE_HEAD
              }
              rowCount={tableData?.length}
              numSelected={selected?.length}
              onSort={onSort}
            />

            <TableBody>
              {!isLoading &&
                dataFiltered
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <AssessmentTableRow
                      key={row.id}
                      row={row}
                      selected={selected.includes(row.id)}
                      onSelectRow={() => onSelectRow(row.id)}
                      onDeleteRow={() => handleDeleteRow(row.id)}
                      onAddScore={() => handleAddAssessmentScore(row.id)}
                      hideActions={hideActions}
                    />
                  ))}

              <TableEmptyRows
                height={denseHeight}
                emptyRows={emptyRows(page, rowsPerPage, tableData.length)}
              />

              <TableNoData isNotFound={isNotFound} />
            </TableBody>
          </Table>
        </Scrollbar>
      </TableContainer>

      <TablePaginationCustom
        count={dataFiltered?.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        //
        dense={dense}
        onChangeDense={onChangeDense}
      />

      <Stack pt={3} sx={{ borderTop: "1px solid #000" }}>
        {program && id && (
          <AssessmentReport
            student_id={id}
            subject_code={program}
            student={student}
          />
        )}
      </Stack>
      <AddAssessment
        open={assessmentOpen}
        onClose={handleAssessmentClose}
        courses={enrollments?.map((i) => i.program_name)}
        selectedProgram={program}
      />
    </StudentTabContainer>
  );
}

// ----------------------------------------------------------------------

function applyFilter({
  inputData,
  comparator,
  filterName,
  filterStatus,
  filterRole,
}) {
  const stabilizedThis = inputData?.map((el, index) => [el, index]);

  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  inputData = stabilizedThis?.map((el) => el[0]);

  if (filterName) {
    inputData = inputData?.filter(
      (user) => user.name.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
    );
  }

  if (filterStatus !== "all") {
    inputData = inputData.filter((user) => user.status === filterStatus);
  }

  if (filterRole !== "all") {
    inputData = inputData?.filter((user) => user?.role === filterRole);
  }

  return inputData;
}
